import * as React from "react";
import { useState } from 'react';
import { initializeIcons, Icon } from '@fluentui/react';
import { Avatar, Button, Flex, Image, Label, Segment, Text, Tooltip, Provider, teamsTheme, ChatIcon, CallVideoIcon } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import Acs from '../../acs/acs';
import Timer from '../../../helpers/timer';
import Channels from "../../../constants/channels";

interface IQueueStartedProps extends WithTranslation {
    botWriting1: boolean;
    appConfigs: any;
    appSettings: any;
    meetingData: any;
    meetingQueueData: any;
    startCall: any;
    joinChat: any;
    callInProgress: boolean;
    timerTimeout: any;
    scheduled: boolean;
    acsEnabled: boolean;
    teamsContext: boolean;
}

const QueueStartedCard: React.FunctionComponent<IQueueStartedProps> = props => {
    const localize = props.t;
    const meetingQueueChannel = props.meetingQueueData.channel;
    const [acsUserJoined, setAcsUserJoined] = useState<boolean>(false);

    const acsUserStarted = () => {
        setAcsUserJoined(true);
    }

    initializeIcons();

    return (
        <React.Fragment>
            <Flex gap="gap.medium" className="card" styles={{ margin: "4rem 0" }}>
                <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                <Image hidden={!props.botWriting1} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                <Flex.Item grow>
                    <Segment
                        hidden={props.botWriting1}
                        className="dialog2 dialog"
                        content={
                            <Flex gap="gap.large" column>
                                <Text className="header-text" content={localize("Proximo")} />
                                <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                <Flex>
                                    <Flex vAlign="center" className="endLabel" fill column>
                                        <Flex gap="gap.medium" padding="padding.medium" hAlign="center" column>
                                            <Text
                                                align="center"
                                                weight="light"
                                                size="medium"
                                                content={
                                                    props.callInProgress ?
                                                        `${localize("SeuAtendimentoIniciado")}`
                                                        :
                                                        `${localize("SuaVezChegou")}`
                                                }
                                            />

                                            {props.teamsContext && meetingQueueChannel === Channels.bot && !props.acsEnabled &&
                                                <Button
                                                    className="join-meeting"
                                                    icon={<ChatIcon outline />}
                                                    hidden={(props.callInProgress && props.acsEnabled)}
                                                    content={localize("EntrarConversa")}
                                                    onClick={props.joinChat}
                                                    primary
                                                />
                                            }

                                            {!props.teamsContext &&
                                                <Button
                                                    className="join-meeting"
                                                    icon={<CallVideoIcon outline />}
                                                    hidden={(props.callInProgress && props.acsEnabled)}
                                                    content={localize("EntrarAtendimento")}
                                                    onClick={props.startCall}
                                                    styles={{
                                                        root: (props.callInProgress && props.acsEnabled) ? { display: 'none'} : { display: 'inline-flex !important' },
                                                        display: (props.callInProgress && props.acsEnabled) ? 'none' : 'inline-flex !important'
                                                    }}
                                                    primary
                                                />
                                            }

                                            <Flex hAlign="center">
                                                {!props.callInProgress && props.appConfigs && !props.scheduled &&
                                                    <Flex className="timer highlight">
                                                        <Timer
                                                            hidden={props.callInProgress}
                                                            initialSeconds={props.appConfigs.queueWaitTime}
                                                            onFinishCount={props.timerTimeout}
                                                        />
                                                    </Flex>
                                                }
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                    {props.appConfigs && props.appConfigs.imgEnd != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgEnd} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgEnd == "" &&
                                        <Flex.Item align="end" className="fila">
                                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/fim.svg" className="filaImg" />
                                        </Flex.Item>
                                    }
                                </Flex>
                            </Flex>
                        }
                    />
                </Flex.Item>
            </Flex>

            {(props.callInProgress && props.acsEnabled) &&
                <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting1} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text
                                        className="header-text"
                                        content={!acsUserJoined ? localize("AcsIntro") : localize("AcsAtendimentoIniciado")}
                                    />

                                    {props.callInProgress &&
                                        <Acs
                                            queueData={props.meetingQueueData}
                                            userStarted={acsUserStarted}
                                        />
                                    }
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
        </React.Fragment>
    );
};

const queueStartedWithTranslation = withTranslation()(QueueStartedCard);
export default queueStartedWithTranslation;